import { Logger as logger } from '@krakenjs/beaver-logger'

const beaverLogger = logger({
  url: '/offers/rest/log'
})

export default beaverLogger
